import * as Yup from "yup";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { errorToast, successToast } from "../../../components/Toast";
import { useRef, useState } from "react";
import { updatePasswordApi } from "../../../services/super-admin-service/_company";

interface Props {
  id: string;
  email: string;
  companyId: string;
}

const UpdatePassword: React.FC<Props> = ({ id, email, companyId }) => {
  const cancelButtonRef = useRef<HTMLButtonElement | null>(null);
  const [updateLoading, setUpdateLoading] = useState<boolean>(false);
  const loginValidationSchema = Yup.object().shape({
    password: Yup.string().required("Password is required"),
    confirm_password: Yup.string()
      .required("Confirm password is required")
      .oneOf([Yup.ref("password")], "Password and confirm password must match"),
  });

  const loginInitialValues = {
    password: "",
    confirm_password: "",
  };

  const handleSubmit = async (
    values: any,
    { resetForm }: { resetForm: () => void }
  ) => {
    setUpdateLoading(true);
    values.adminId = id;
    values.companyId = companyId;
    const result: any = await updatePasswordApi(values);
    if (result.isSuccess) {
      resetForm();
      setUpdateLoading(false);
      successToast(result.message);

      if (cancelButtonRef.current) {
        cancelButtonRef.current.click();
      }
    } else {
      errorToast(result.message);
    }
    setUpdateLoading(false);
    return;
  };

  return (
    <div
      className="modal fade"
      id="updateUserPassword"
      tabIndex={-1}
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg modal-simple modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
            <div className="text-center mb-6">
              <h4 className="mb-2">Change Password</h4>
              <p>
                <strong>Email:</strong>: {email}
              </p>
            </div>
            <Formik
              initialValues={loginInitialValues}
              validationSchema={loginValidationSchema}
              onSubmit={handleSubmit}
            >
              {({ handleChange }) => {
                return (
                  <Form className="row g-6">
                    <div className="col-12 col-md-6">
                      <label className="form-label" htmlFor="password_1">
                        Password: <span className="text-danger">*</span>
                      </label>
                      <div className="input-group input-group-merge">
                        <Field
                          type="password"
                          onChange={handleChange}
                          id="password_1"
                          className="form-control"
                          name="password"
                          placeholder="Enter Password"
                        />
                      </div>
                      <ErrorMessage
                        name="password"
                        className="text-danger"
                        component="div"
                      />
                    </div>
                    <div className="col-12 col-md-6">
                      <label
                        className="form-label"
                        htmlFor="confirm_password_1"
                      >
                        Confirm Password: <span className="text-danger">*</span>
                      </label>
                      <div className="input-group input-group-merge">
                        <Field
                          type="password"
                          onChange={handleChange}
                          id="confirm_password_1"
                          className="form-control"
                          name="confirm_password"
                          placeholder="Enter Confirm Password"
                        />
                      </div>
                      <ErrorMessage
                        name="confirm_password"
                        className="text-danger"
                        component="div"
                      />
                    </div>
                    <div className="col-12 text-center">
                      <button
                        type="submit"
                        className="btn btn-primary me-3"
                        disabled={updateLoading}
                      >
                        {updateLoading && (
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        )}
                        Submit
                      </button>
                      <button
                        ref={cancelButtonRef}
                        type="reset"
                        className="btn btn-label-secondary"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      >
                        Cancel
                      </button>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdatePassword;
